(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["usf-browse-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('usf-browse-menu')) {
  customElements.define('usf-browse-menu', class extends HTMLElement {
    static cardCache = new Map();
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.tabs = [...this.querySelectorAll('[data-usf-tab]')];
      this.accordions = [...this.querySelectorAll('[data-usf-accordion]')];
      this.panel = this.querySelector('[data-usf-panel]');
      this.status = this.querySelector('[data-usf-status]');
      this.controllers = new Set();
      this.sequence = 0;
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-usf-tab]');
        if (!tab || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); this.show(tab);
      });
      this.addEventListener('toggle', event => {
        if (event.target.matches?.('[data-usf-accordion]') && event.target.open) this.loadPane(event.target.querySelector('[data-usf-pane]'));
      }, true);
      this.querySelector('[data-usf-search]').addEventListener('input', event => {
        const term = event.target.value.toLocaleLowerCase().trim();
        const entries = this.tabs.length ? this.tabs : this.accordions;
        for (const entry of entries) entry.hidden = !(entry.dataset.title || entry.querySelector('summary').textContent).toLocaleLowerCase().includes(term);
        for (const group of this.querySelectorAll('[data-usf-group]')) group.hidden = ![...group.querySelectorAll('[data-usf-tab],[data-usf-accordion]')].some(entry => !entry.hidden);
        const visible = entries.filter(entry => !entry.hidden);
        this.status.textContent = visible.length ? '' : this.dataset.noResults.replace('__term__', event.target.value);
        if (this.tabs.length) {
          for (const tab of this.tabs) tab.tabIndex = -1;
          const active = visible.find(tab => tab.getAttribute('aria-selected') === 'true') || visible[0];
          if (active) active.tabIndex = 0;
        }
      });
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-usf-tab]');
        if (!tab || !['ArrowUp','ArrowDown','Home','End',' '].includes(event.key)) return;
        event.preventDefault();
        const visible = this.tabs.filter(tab => !tab.hidden), index = visible.indexOf(tab);
        let next = tab;
        if (event.key === 'ArrowDown') next = visible[(index + 1) % visible.length];
        if (event.key === 'ArrowUp') next = visible[(index - 1 + visible.length) % visible.length];
        if (event.key === 'Home') next = visible[0];
        if (event.key === 'End') next = visible[visible.length - 1];
        next.focus(); this.show(next);
      });
    }
    disconnectedCallback() { for (const controller of this.controllers || []) controller.abort(); }
    async show(tab) {
      const sequence = ++this.sequence;
      for (const item of this.tabs) {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
      }
      this.status.textContent = '';
      this.panel.setAttribute('aria-labelledby', tab.id);
      const template = [...this.querySelectorAll('[data-usf-panel-template]')].find(item => item.dataset.usfPanelTemplate === tab.getAttribute('href'));
      if (!template) return;
      this.panel.replaceChildren(template.content.cloneNode(true));
      await this.loadPane(this.panel.querySelector('[data-usf-pane]'));
      if (sequence === this.sequence) this.panel.scrollTop = 0;
    }
    async loadPane(pane) {
      if (!pane || pane.hasAttribute('data-loaded') || pane.dataset.loading) return;
      pane.dataset.loading = 'true';
      pane.setAttribute('aria-busy','true');
      const controller = new AbortController();
      this.controllers.add(controller);
      const format = pane.dataset.format;
      const products = JSON.parse(pane.querySelector('[data-usf-products]').textContent);
      const status = pane.querySelector('[data-usf-pane-status]');
      try {
        const cards = await Promise.all(products.map(async product => {
          const root = window.Shopify?.routes?.root || '/';
          const url = new URL(root + 'products/' + encodeURIComponent(product.handle), location.origin);
          url.searchParams.set('section_id','usf-menu-card');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id',preview);
          const key = url.href + '#' + format;
          let html = this.constructor.cardCache.get(key);
          if (!html) {
            const response = await fetch(url,{signal:controller.signal,credentials:'same-origin'});
            if (!response.ok) throw new Error('product');
            const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
            const template = parsed.querySelector('template[data-usf-card-format="' + format + '"]');
            if (!template || !template.innerHTML.trim()) throw new Error('card');
            html = template.innerHTML;
            this.constructor.cardCache.set(key,html);
            if (this.constructor.cardCache.size > 64) this.constructor.cardCache.delete(this.constructor.cardCache.keys().next().value);
          }
          return html.replaceAll('__usf_instance__',pane.dataset.instance);
        }));
        const slider = pane.querySelector('.usf-pane__product-area');
        const rebuilt = slider.cloneNode(true);
        rebuilt.querySelector('[data-usf-cards]').innerHTML = cards.join('');
        slider.replaceWith(rebuilt);
        pane.setAttribute('data-loaded','');
      } catch (error) {
        if (error.name !== 'AbortError') status.textContent = this.dataset.error;
      } finally {
        pane.removeAttribute('aria-busy'); delete pane.dataset.loading; this.controllers.delete(controller);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
